import React from 'react';
import { Refresh as RefreshIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import { GENERATE_NEW_CODES } from 'common/constants/login';
import { GenerateBackupCodesButtonProps } from './GenerateBackupCodesButton.props';

const GenerateBackupCodesButton = ({ className, generateNewBackupCodes, disabled }: GenerateBackupCodesButtonProps) => (
  <Button
    className={className}
    variant="contained"
    color="primary"
    onClick={generateNewBackupCodes}
    disabled={disabled}
    startIcon={<RefreshIcon />}>
    {GENERATE_NEW_CODES}
  </Button>
);

export default GenerateBackupCodesButton;
